// enci.alternatelayout.js
'use strict';

import { debugLog } from '../enci.log.js';

class AlternateLayoutManager {
  async initializeComponent(componentName, isAdmin) {
    debugLog(
      `AlternateLayoutManager.initializeComponent >> Initializing ${componentName}: isAdmin=${isAdmin}`
    );

    try {
      debugLog(
        `AlternateLayoutManager.initializeComponent >> ${componentName} initialized successfully`
      );
    } catch (error) {
      debugLog(
        `AlternateLayoutManager.initializeComponent >> Error in ${componentName} initialization: ${error.message}`,
        {
          type: 'error',
        }
      );
      throw error;
    }
  }

  async initializeThemeRoute() {
    debugLog(`AlternateLayoutManager.initializeThemeRoute >> Initializing theme route`);

    try {
      debugLog(
        `AlternateLayoutManager.initializeThemeRoute >> Theme route initialized successfully`
      );
    } catch (error) {
      debugLog(`AlternateLayoutManager.initializeThemeRoute >> Error: ${error.message}`, {
        type: 'error',
      });
      throw error;
    }
  }

  async cleanupComponent(componentName) {
    debugLog(`AlternateLayoutManager.cleanupComponent >> Cleaning up ${componentName}`);

    try {
      debugLog(
        `AlternateLayoutManager.cleanupComponent >> ${componentName} cleaned up successfully`
      );
    } catch (error) {
      debugLog(
        `AlternateLayoutManager.cleanupComponent >> Error cleaning up ${componentName}: ${error.message}`,
        {
          type: 'error',
        }
      );
      throw error;
    }
  }
}

// Create instance
const alternateLayoutManager = new AlternateLayoutManager();

// Export functions that will be called from C#
export const initializeComponent = async (componentName, isAdmin) =>
  alternateLayoutManager.initializeComponent(componentName, isAdmin);
export const cleanupComponent = async componentName =>
  alternateLayoutManager.cleanupComponent(componentName);
export const initializeThemeRoute = async () => alternateLayoutManager.initializeThemeRoute();

// Export the manager instance
export { alternateLayoutManager };
